import React, { useState } from "react";
import logo from "../../assets/logo.png";
import menuIcon from "../../assets/menu-icon.png";
import Menu from "../Menu/Menu";
import "./ProductHeader.css";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="product-header">
      <img src={logo} alt="Logo" className="logo" />
      <img
        src={menuIcon}
        alt="Menu"
        className="menu-icon"
        onClick={toggleMenu}
      />
      <Menu isOpen={isMenuOpen} onClose={toggleMenu} />
    </header>
  );
};

export default Header;
